import { Box, Paper, Stack, Typography } from '@mui/material';
import { useFormikContext } from 'formik';
import {
  AppFormikTextArea,
  AppFormikTextField,
} from 'shared/components/AppComponents';

const BasicInformationForm: React.FC = () => {
  const { values, setFieldValue }: any = useFormikContext();
  const MAX_CHARACTERS = 100;
  return (
    <Paper variant="outlined" className="basic-information-form">
      <Typography variant="h6">Basic Information</Typography>
      <Stack direction="column" spacing={2}>
        <Box className="basic-information-title">
          <AppFormikTextField
            name="title"
            placeholder="Concise label (e.g., ‘Prompt-Injection via System Message) "
            outerLabel
            label="Vulnerability Title*"
            onChange={(event: any) => {
              const { value } = event.target;
              if (value && value.length > MAX_CHARACTERS) {
                setFieldValue(
                  'title',
                  value.substring(0, MAX_CHARACTERS),
                  true
                );
              }
            }}
          />
        </Box>
        <Typography component="span">
          {values.title.length}/{MAX_CHARACTERS} characters
        </Typography>
      </Stack>
      <Box className="basic-information-description">
        <AppFormikTextArea
          name="description"
          placeholder="Technical summary of the weakness and how it manifests"
          label="Description"
          outerLabel
          rows={4}
        />
      </Box>
    </Paper>
  );
};

export default BasicInformationForm;
